/***
 * Created on 2023/8/30
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import ModalDialog from "../../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {apiPut} from "../../../../../../service/api";
import {getPrimaryEmail} from 'common/ServiceUser';

function AddPhoneStep3({show, closeWizard, dispatch, state}) {
    const { t } = useTranslation();
    const [checked, setChecked] = useState(false);

    const activateMutate = useMutation({
        mutationFn: async (data) => await apiPut(`/ajax/activate_two_step`, data),
        onSuccess: data => {
            dispatch({type: 'updateSMSPanel'})
            closeWizard();
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onSave = async () => {
        const data = {
            set_trust: checked,
            two_step_enabled: true
        }
        await activateMutate.mutateAsync(data);
    }

    return (
        <ModalDialog title={t('@Add phone number@')} showModal={show} closeModal={closeWizard} submitText={t('@Save@')} submitAction={onSave}>
            <div className="dialog-content">
                <div className="dialog__sub-title color-primary">{t('@Code accepted!@')}</div>
                <p>{t('@You can access your account from a trusted computer without needing a verification.@')}</p>
                <div className="comp-checkbox">
                    <label className="q-checkbox">
                        <input type="checkbox" name="checkbox-checked" checked={checked} onChange={()=>setChecked(prev=>!prev)}/>
                        {t('@Trust this device@')}
                    </label>
                </div>
                <div className="dialog__row-divide mt-20 mb-20"></div>
                <div className="dialog__form-group">
                    <label>{t('@Backup Option@')}</label>
                    <p className="!mb-16">
                        {t('@If you your phone is unavailable, a verification code will be sent to your QID email address as backup option. PLease make sure your email is valid and accessible. We strongly recommend that you send a test code to your email.@')}
                    </p>
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <input type="text" value={getPrimaryEmail()} disabled={true}/>
                            <button className="q-btn q-btn-default">{t('@Send code@')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default AddPhoneStep3;